
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { setEnterprise } from '@/api/universal'

@Component({
  name: 'Picsloader'
})
export default class extends Vue {
  @Prop({ required: true }) private list!: any

  get language() {
    return AppModule.language
  }

  private changeValue (val) {
    this.$forceUpdate()
  }
  private safetyNotifySms (val) {
    console.log(val)
  }

  private async openSendMes () {
    try {
      const data: any = {
        ssl_switch: {
          telegram_robot_comds: this.list
        }
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })

        this.$emit('close', false)
      })
    } catch (e) {
      console.log()
    }
  }

  mounted () {
  }

  created () {
  }
}
